import get from "lodash/get";
import { _calculatePayments } from "@/pixels/providers/utils/adobeFunctions";

/**
 * Verificar si el dispositivo es mobile o no
 */
export const _isMobile = () => {
  // Check for touch support
  const hasTouchSupport =
    "ontouchstart" in window ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0;

  // Check screen size
  const isSmallScreen = window.matchMedia("(max-width: 768px)").matches;

  return hasTouchSupport && isSmallScreen;
};

export const typologyTagging = () => {
  if (_BBVA_MOTOR === "ofertaPrestamosEmprendedores") {
    return "emprendedores";
  }
  if (_BBVA_MOTOR === "ofertaHipotecarios") {
    return "hipotecarios";
  }
  return "individuos";
};

export const bodyProductAttributes = (value, context) => {
  let currency = "ARS";
  let cantidadCuotas = String(get(context, "state.oferta.plazo", ""));
  let montoTotal = String(get(context, "state.oferta.monto", "")).replace(
    /\D/g,
    ""
  );
  let montoSolicitadoHipotecario = String(
    get(context, "state.simulacion.montoSolicitado", "")
  );
  let cuotaHipotecario = String(
    get(context, "state.simulacion.repagos[0].phEnPesos.cuota", "")
  );
  let cantidadCuotasHipotecario = _calculatePayments(
    get(context, "state.consultaHipotecario.plazo", "")
  );

  const BODYCUENTAS = {
    primaryCategory: "cuentas",
    productSubtype: "caja de ahorro",
    productName: "caja de ahorro pesos"
  };
  const BODYTARJETAS = {
    primaryCategory: "tarjetas",
    productSubtype: "tarjetas de debito",
    productName: "tarjetas de debito tradicional"
  };
  const BODYHIPOTECARIO = {
    primaryCategory: "prestamos",
    productSubtype: "prestamos hipotecarios",
    numberOfPayments: cantidadCuotasHipotecario,
    amount: montoSolicitadoHipotecario,
    currency: currency,
    paymentAmount: cuotaHipotecario
  };
  const BODYPERSONAL = {
    primaryCategory: "prestamos",
    productSubtype: "",
    productName: "prestamo personal",
    numberOfPayments: cantidadCuotas,
    amount: montoTotal,
    currency: currency
  };
  if (value === "cuentas") {
    return BODYCUENTAS;
  }
  if (value === "tarjetas") {
    return BODYTARJETAS;
  }
  if (value === "hipotecario") {
    return BODYHIPOTECARIO;
  }
  return BODYPERSONAL;
};
